import type { Headline } from '@daily/shared';

interface HeadlineCardProps {
  headline: Headline;
  size?: 'sm' | 'md' | 'lg';
}

export function HeadlineCard({ headline, size = 'md' }: HeadlineCardProps) {
  const sizeClass =
    size === 'lg' ? 'text-display-md' : size === 'sm' ? 'text-body-lg' : 'text-display-sm';
  return (
    <p className={`font-serif italic text-ink ${sizeClass} leading-snug max-w-3xl`}>
      {headline.text}
    </p>
  );
}
